import LabeledToggle from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/LabeledToggle';

import { GAP_POLICY_BASE_RATE, GAP_POLICY_MASK, GAP_POLICY_VALUES, TEST_ID } from './constants';
import type { FunctionComponent, PrescriptionGapPolicy, Props } from './types';

import styles from './styles.module.scss';

const GapPolicyPicker: FunctionComponent<Props> = ({
    baseRateLabel,
    className = '',
    gapPolicy,
    label,
    maskLabel,
    onGapPolicyChange,
    testId = TEST_ID
}) => {
    const options = [
        { label: maskLabel, value: GAP_POLICY_MASK },
        { label: baseRateLabel, value: GAP_POLICY_BASE_RATE }
    ];
    const activeIndex = GAP_POLICY_VALUES.indexOf(gapPolicy);

    const handleClick = (value: string) => {
        onGapPolicyChange({ gapPolicy: value as PrescriptionGapPolicy });
    };

    return (
        <LabeledToggle
            activeIndex={activeIndex}
            className={`${className} ${styles.gapPolicyPicker}`}
            label={label}
            onClick={handleClick}
            options={options}
            testId={testId}
        />
    );
};

export default GapPolicyPicker;
